import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { stripHTML } from 'shared/helpers/strings';
import statusColors from 'shared/constants/json/statusColors.json';
import CheckedVinBlock from 'shared/components/CheckedVinBlock/CheckedVinBlock';
import AdvertStatusList from 'shared/components/AdvertStatusList/AdvertStatusList';

import s from './AdvertDescription.css';

class AdvertDescription extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    advert: PropTypes.shape().isRequired,
    description: PropTypes.string,
    statuses: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      }),
    ),
    isDealer: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    title: '',
    advert: {},
    description: undefined,
    isDealer: false,
    options: [],
    statuses: [],
  };

  render() {
    const { intl, advert } = this.props;
    const {
      title,
      description = intl.formatMessage({ id: 'Нет описания' }),
      statuses,
      isDealer,
    } = this.props;
    const titleResult = `${intl.formatMessage({ id: 'Описание' })} ${title} ${
      !isDealer ? intl.formatMessage({ id: 'от владельца' }) : ''
    }`;
    return (
      <div className={s.root}>
        {advert.vehreg_info && !!advert.vehreg_info.transport.id && (
          <CheckedVinBlock advert={advert} />
        )}
        <div className={s.description}>
          <h2 className={s.title}>{titleResult}</h2>
          <AdvertStatusList statuses={statuses} colors={statusColors} />
          <div
            className={s.text}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html:
                stripHTML(description)
                  .replace(/\n{3,}/g, '\n\n')
                  .replace(/\n/g, '<br />') || intl.formatMessage({ id: 'Нет описания' }),
            }}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(AdvertDescription));



// WEBPACK FOOTER //
// ./src/shared/components/AdvertDescription/AdvertDescription.js